export default theme => ({
  flexContainer: {
    display: "flex",
  },
  flexDate: {
    flexGrow: 2,
  },
  flexButton: {
    flexGrow: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: 20,
  },
});
